import { createFileRoute } from '@tanstack/react-router';
import { DirectoryGrid } from '~/components/ninety/DirectoryGrid';

export const Route = createFileRoute('/_app/ninety/directory')({
  component: DirectoryGrid,
});
